import classNames from "classnames";
import React, {ReactNode} from "react";
import styles from "../DropdownItem/DropdownItem.module.scss";

interface DropdownItemTextProps {
  children?: ReactNode;
  className?: string;
}

const DropdownItemText = React.forwardRef(
  ({children, className = "", ...props}: DropdownItemTextProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <span
        className={classNames("dropdown-item-text pulseTextBodySmall", styles.dropdownItem, className)}
        ref={ref}
        {...props}
      >
        {children}
      </span>
    );
  }
);

DropdownItemText.displayName = "DropdownItemText";
export {DropdownItemText};
